// extracted by mini-css-extract-plugin
export default {"column":"index_column_OyL4n","tumourShotTh":"index_tumourShotTh_SxlvD","tumourShotBd":"index_tumourShotBd_3vURC"};